// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@2.1.1_webpack@5.108.2_postcss@8.5.16_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@2.1.1_webpack@5.108.2_postcss@8.5.16_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a11y-modal-title{unicode-bidi:isolate;margin-block:1.33em;margin-inline:0;font-weight:700;display:block}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
